module.exports = __webpack_public_path__ + "assets/img/activity-time-ac4182ae.png";